const isProd: boolean = import.meta.env.VITE_NODE_ENV === 'production';

const backendAPI: string = import.meta.env.VITE_VENDOR_SERVICE_URL || '';

export const APP_CONFIG = {
  isProd,
  backendAPI,
};
